import * as types from '../mutation-types'
import reportsService from '../../services/reports'
import { calcDiscount, getBillSum } from '../../common/index'

const state = {
  loading: false,
  errors: null,
  revenue: {
    all_feepayments: [],
    feespayment_sum: 0,
    arrears_sum: 0,
    incomes: [], //other incomes apart from fees
    income_sum: 0,

  },
  expenses: {
    all_expenses: [],
    expense_sum: 0.00, //overall expense sum
    expla_summaries: [] //expense ledger account summaries
  },
  banking: {
    all_transactions: [],
    cash_at_bank: 0,
    bacc_summaries: []
  },
}

const actions = {
  getRevenueRpt({ commit },reqData) {
    commit('ResetRpt')
    commit(types.RPT_LOADING, true)
    reportsService.getRevenueRpt(reqData).then(
      response => {

        commit(types.LOAD_REVENUERPT, response.data)
        commit(types.RPT_LOADING, false)
        commit(types.RPT_FAILURE, null)
      },
      error => {
        commit(types.RPT_FAILURE, error)
        commit(types.RPT_LOADING, false)
      }
    )
  },
  getExpensesRpt({ commit },reqData) {
    commit('ResetRpt')
    commit(types.RPT_LOADING, true)
    reportsService.getExpenseRpt(reqData).then(
      response => {

        commit(types.LOAD_EXPENSESRPT, response.data)
        commit(types.RPT_LOADING, false)
        commit(types.RPT_FAILURE, null)
      },
      error => {
        commit(types.RPT_FAILURE, error)
        commit(types.RPT_LOADING, false)
      }
    )
  },
  getBankingRpt({ commit },reqData) {
    commit('ResetRpt')
    commit(types.RPT_LOADING, true)
    reportsService.getBankingRpt(reqData).then(
      response => {

        commit(types.LOAD_BANKINGRPT, response.data)
        commit(types.RPT_LOADING, false)
        commit(types.RPT_FAILURE, null)
      },
      error => {
        commit(types.RPT_FAILURE, error)
        commit(types.RPT_LOADING, false)
      }
    )
  },

}

const mutations = {

  ResetRpt(state) {

    state.revenue = {
      all_feepayments: [],
      feespayment_sum: 0,
      arrears_sum: 0,
      incomes: [], //other incomes apart from fees
      income_sum: 0,

    }
    state.expenses = {
      all_expenses: [],
      expense_sum: 0.00, //overall expense sum
      expla_summaries: []
    }
    state.banking = {
      all_transactions: [],
      cash_at_bank: 0,
      bacc_summaries: []
    }

  },

  [types.LOAD_REVENUERPT](state, payload) {

    const c_bills = this.state.billings.cls_billSums

    let new_payload = payload.feespayments.map(x => {
      x.tot_paid = x.s_payments.reduce((sum, val) => {
        return sum + parseFloat(val.amount)
      }, 0)
       let xpc = JSON.parse(x.p_charges)

      let xpcharges =xpc? xpc.reduce((sum,val)=>{ //sum of all personal charges of student besides class bill
        return sum+=parseFloat(val.amount)
      },0):0

      let xsclassbill = getBillSum(x.class_id, c_bills)

      xpcharges = xsclassbill>0?xpcharges:0 //setting personal charges to 0 incase class has not been billed yet. just for display but in controller it will be used to calculate arrears remaining


      let ottl_bill = xpcharges>0?parseFloat(xpcharges)+parseFloat(xsclassbill):xsclassbill



      let xsdiscval = calcDiscount(x.s_discount, ottl_bill)
      x.fees_arrears = xsclassbill>0?x.fees_arrears:0 //setting arrears to 0 for display purposes if class has not been billed
      x.tot_bill = (ottl_bill + parseFloat(x.fees_arrears))

      x.remaining_fee = x.tot_bill - (Number(x.tot_paid) + Number(xsdiscval))
      x.fee_status = x.remaining_fee && x.remaining_fee > 0 ? "owing" : "fully paid"
      x.fee_status = xsclassbill>0?x.fee_status:"Not Billed" //setting fee status to not billed for all students if class is not billed

      //console.log(x.remaining_fee)

      return x

    })


    //arrears_sum: 0,




    state.revenue.all_feepayments = new_payload
    state.revenue.feespayment_sum = new_payload.reduce((sum,val)=>{
      return sum+=parseFloat(val.tot_paid)
    },0)
    state.revenue.arrears_sum+=new_payload.reduce((sum,val)=>{
      return sum+=parseFloat(val.remaining_fee)
    },0)

    state.revenue.incomes = payload.incomes
    state.revenue.income_sum = payload.incomes.reduce((sum,val)=>{
      return sum+=parseFloat(val.amount)
    },0)


    console.log("re calculateeddddd",state.revenue.all_feepayments)
  },

  [types.LOAD_EXPENSESRPT](state, payload) {
    state.expenses.all_expenses = payload //setting all expenses from db

    state.expenses.expense_sum = payload.reduce((sum,exp)=>{ //calculating expense sum
      return sum+=parseFloat(exp.amount);
    },0)

    let expla_calc_res =  []
    state.expenses.all_expenses.forEach(function(a){ //calculating and grouping expense ledger account summaries
      if(!this[a.ledgeracc_id]){
        this[a.ledgeracc_id] = {ledgeracc:a.ledgeracc.name,amount:0}
        expla_calc_res.push(this[a.ledgeracc_id])
      }
      this[a.ledgeracc_id].amount+=parseFloat(a.amount)

    },Object.create(null))


    state.expenses.expla_summaries = expla_calc_res

    //console.log(state.expenses)
  },
  [types.LOAD_BANKINGRPT](state, payload) {
    state.banking.all_transactions = payload.banktrans



    state.banking.cash_at_bank = payload.bankaccs.reduce((sum,bk)=>{
      return sum+=parseFloat(bk.balance)
    },0)

    let  basummariesarr= [];

    state.banking.all_transactions?state.banking.all_transactions.forEach(function(b){
      if(!this[b.bankacc_id]){
        this[b.bankacc_id] = {bankacc:b.bankacc.bank_name+' ('+b.bankacc.acc_num+')',dr:0,cr:0}
        basummariesarr.push(this[b.bankacc_id])
      }

      if(b.tran_type=='debit'){
        this[b.bankacc_id].dr+=parseFloat(b.amount)
      }else{
        this[b.bankacc_id].cr+=parseFloat(b.amount)
      }
      this[b.bankacc_id].balance = parseFloat(b.bankacc.balance)

    },Object.create(null)):0


    state.banking.bacc_summaries =basummariesarr;

    //console.log(state.banking)

  },
  [types.RPT_FAILURE](state, payload) {
    state.errors = payload
  },

  [types.RPT_LOADING](state, payload) {
    state.loading = payload
  },
}


const getters = {
  REVENUERPT: state => {
    return state.revenue
  },

  EXPENSESRPT: state => {
    return state.expenses
  },
  BANKINGRPT: state => {
    return state.banking
  },

  RPT_LOADING: state => {
    return state.loading
  },
  RPT_ERROR: state => {
    return state.errorS
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/reports.js